module.exports = __webpack_public_path__ + "img/logout.81c3faeb.svg";